import React, { useState } from 'react';
import Styles from './BensServicosBanner.css';
import WhiteButton from '@/components/atoms/WhiteButton';
import ContainerHome24 from '@/components/atoms/ContainerHome24';

function BensServicosBanner({ tab }) {
  console.log(tab);
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="bens-servicos-banner" className="stacked-banner">
        <div className="bg-image-wrapper">
          {tab == 0 && (
            <>
              {typeof window === 'undefined' ? (
                <></>
              ) : (
                <>
                  {width <= 320 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-320.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-320.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pf/hero-320.png"
                        alt="Pessoa com celular realizando um parcelamento de bens e serviços com a Santander Financiamentos."
                      />
                    </picture>
                  )}
                  {width > 320 && width <= 450 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-450.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-450.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pf/hero-450.png"
                        alt="Pessoa com celular realizando um parcelamento de bens e serviços com a Santander Financiamentos."
                      />
                    </picture>
                  )}
                  {width > 450 && width <= 800 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-800.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-800.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pf/hero-800.png"
                        alt="Pessoa com celular realizando um parcelamento de bens e serviços com a Santander Financiamentos."
                      />
                    </picture>
                  )}
                  {width > 800 && width <= 992 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-992.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-992.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pf/hero-992.png"
                        alt="Pessoa com celular realizando um parcelamento de bens e serviços com a Santander Financiamentos."
                      />
                    </picture>
                  )}
                  {width > 992 && width <= 1280 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-1280.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-1280.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pf/hero-1280.png"
                        alt="Pessoa com celular realizando um parcelamento de bens e serviços com a Santander Financiamentos."
                      />
                    </picture>
                  )}
                  {width > 1280 && width <= 1360 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-1360.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-1360.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pf/hero-1360.png"
                        alt="Pessoa com celular realizando um parcelamento de bens e serviços com a Santander Financiamentos."
                      />
                    </picture>
                  )}
                  {width > 1360 && width <= 1440 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-1440.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-1440.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pf/hero-1440.png"
                        alt="Pessoa com celular realizando um parcelamento de bens e serviços com a Santander Financiamentos."
                      />
                    </picture>
                  )}
                  {width > 1440 && width <= 1920 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-1920.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-1920.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pf/hero-1920.png"
                        alt="Pessoa com celular realizando um parcelamento de bens e serviços com a Santander Financiamentos."
                      />
                    </picture>
                  )}
                  {width > 1920 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-2650.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pf/hero-2650.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pf/hero-2650.png"
                        alt="Pessoa com celular realizando um parcelamento de bens e serviços com a Santander Financiamentos."
                      />
                    </picture>
                  )}
                </>
              )}
            </>
          )}
          {tab == 1 && (
            <>
              {typeof window === 'undefined' ? (
                <></>
              ) : (
                <>
                  {width <= 400 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-400.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-400.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pj/hero-400.png"
                        alt="Pessoa usando laptop em ambiente interno, representando ações como simulação de financiamento, crédito pessoal ou parcelamento de bens e serviços."
                      />
                    </picture>
                  )}
                  {width > 400 && width <= 600 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-600.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-600.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pj/hero-600.png"
                        alt="Pessoa usando laptop em ambiente interno, representando ações como simulação de financiamento, crédito pessoal ou parcelamento de bens e serviços."
                      />
                    </picture>
                  )}
                  {width > 600 && width <= 800 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-800.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-800.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pj/hero-800.png"
                        alt="Pessoa usando laptop em ambiente interno, representando ações como simulação de financiamento, crédito pessoal ou parcelamento de bens e serviços."
                      />
                    </picture>
                  )}
                  {width > 800 && width <= 1280 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-1280.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-1280.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pj/hero-1280.png"
                        alt="Pessoa usando laptop em ambiente interno, representando ações como simulação de financiamento, crédito pessoal ou parcelamento de bens e serviços."
                      />
                    </picture>
                  )}
                  {width > 1280 && width <= 1360 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-1360.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-1360.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pj/hero-1360.png"
                        alt="Pessoa usando laptop em ambiente interno, representando ações como simulação de financiamento, crédito pessoal ou parcelamento de bens e serviços."
                      />
                    </picture>
                  )}
                  {width > 1360 && width <= 1440 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-1440.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-1440.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pj/hero-1440.png"
                        alt="Pessoa usando laptop em ambiente interno, representando ações como simulação de financiamento, crédito pessoal ou parcelamento de bens e serviços."
                      />
                    </picture>
                  )}
                  {width > 1440 && width <= 1920 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-1920.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-1920.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pj/hero-1920.png"
                        alt="Pessoa usando laptop em ambiente interno, representando ações como simulação de financiamento, crédito pessoal ou parcelamento de bens e serviços."
                      />
                    </picture>
                  )}
                  {width > 1920 && (
                    <picture>
                      <source
                        type="image/webp"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-2650.webp"
                      />
                      <source
                        type="image/png"
                        srcSet="assets/bens-e-servicos/hero-pj/hero-2650.png"
                      />
                      <img
                        src="assets/bens-e-servicos/hero-pj/hero-2650.png"
                        alt="Pessoa usando laptop em ambiente interno, representando ações como simulação de financiamento, crédito pessoal ou parcelamento de bens e serviços."
                      />
                    </picture>
                  )}
                </>
              )}
            </>
          )}
          {/* <picture>
            <source type="image/webp" srcSet="assets/renegociacao25/hero/hero.webp" />
            <source type="image/png" srcSet="assets/renegociacao25/hero/hero.png" />
            <img src="assets/renegociacao25/hero/hero.png" alt="" />
          </picture> */}
        </div>
        {/* <div className="fade-banner" /> */}
        {/* <div className="fade-banner-gradiente" /> */}
        <div className="santander-symbol" />

        <div className="text-box-position">
          <ContainerHome24>
            <div className="text-box">
              <h1 className="main-text">Parcele suas compras com nossos parceiros</h1>
              <p className="alt-text">
                Aqui você tem a possibilidade de parcelar suas compras no boleto e débito automático
                de forma facilitada. Confira abaixo tudo que você pode parcelar com nosso parceiros.
              </p>
              <WhiteButton
                href={
                  tab == 0
                    ? '#bens-servicos-pf-parcela-facilitada'
                    : '#bens-servicos-pj-parcela-facilitada'
                }
                rel="noopener"
                className="btn-reneg"
              >
                Saiba mais
              </WhiteButton>
            </div>
          </ContainerHome24>
        </div>
      </section>

      <style jsx>{Styles}</style>
    </>
  );
}

export default BensServicosBanner;
